module.exports = __webpack_public_path__ + "static/media/flf-logo-dark.b7b463ff.png";